const normalizeFieldType = (fieldType) => {
  if (!fieldType) return "text";

  const fieldTypeMap = {
    checkboxGroup: "checkboxGroup",
    selectGroup: "selectGroup",
  };

  return fieldTypeMap[fieldType] || fieldType;
};

const normalizeOptions = (options = []) => {
  if (!Array.isArray(options)) {
    return [];
  }

  return options.map((option) => ({
    ...option,
    value: option?.value ?? option?.name ?? option?.label ?? "",
  }));
};

const normalizeField = (field) => {
  const normalizedType = normalizeFieldType(field?.field_type);

  return {
    ...field,
    type: normalizedType,
    title: field?.label,
    options: normalizeOptions(field?.options),
  };
};

const getDocumentFields = (documentConfig = {}, schemaType = "simple") => {
  if (schemaType === "complex") {
    return (documentConfig?.sections || []).flatMap((section) =>
      (section?.fields || []).map((field) => ({
        ...field,
        section: section?.section,
      })),
    );
  }

  return documentConfig?.fields || [];
};

const buildValuesMap = (fields = []) => {
  return fields.reduce((acc, field) => {
    if (!field?.name) {
      return acc;
    }

    if (field.type === "checkbox" && Array.isArray(field?.value)) {
      acc[field.name] = field.value;
      return acc;
    }

    acc[field.name] = field?.value ?? "";
    return acc;
  }, {});
};

export const loadInitials = async (selectedDocument, documents = {}) => {
  if (!selectedDocument?.form_id) {
    return [];
  }

  const documentConfig = documents?.[selectedDocument.form_id];

  if (!documentConfig) {
    return [];
  }

  const rawFields = getDocumentFields(
    documentConfig,
    selectedDocument?.schema_type,
  );
  const fields = rawFields.map(normalizeField);
  const values = buildValuesMap(fields);

  return [
    {
      fields,
      values,
    },
  ];
};
